






















































import Vue from "vue";
import Component from "vue-class-component";
import { Store } from "vuex";
import { State } from "vuex-class";
import "@/directives/directives";
import AuthService from "../services/auth-service";
import "@/styles/Footer.scss"
import "@/styles/animate.scss"
import config from "../services/api-config";

@Component({
  name: "nav-footer"
})
export default class AreaNavigation extends Vue {
  private auth = new AuthService();
  private isAuth = this.auth.isAuthenticated();
  private isPre = false;
  private isPre2 = false;
  private isHadaf = false;

  mounted(){
    let origin = window.location.origin;
    if (origin.toLowerCase().indexOf('hadaf') > -1)
      this.isHadaf = true;
    
    if (localStorage[config.isPre]){
      this.isPre = JSON.parse(localStorage[config.isPre]);
    }


    
    if (localStorage[config.isPre2] && localStorage[config.isPre2] !== 'undefined')
      this.isPre2 = JSON.parse(localStorage[config.isPre2])

    if (!this.isAuth){
      const links = document.getElementById('links');

      if (links){
        links.classList.remove('col-md-6');
        links.classList.remove('offset-md-0');

      }
    }
  }

}
